import type { ReactNode } from 'react';
import { IconButton } from '@viquard/doc-ui/components';
import { IcnPlus } from '@viquard/doc-ui/icons';
import { useCalendarMessages } from '../i18n.js';

export interface CalendarFabProps {
  readonly onClick: () => void;
  readonly label?: string | undefined;
}

/** Mobile-only floating action button. Built on doc-ui's `<IconButton>`
 *  with the `vq-cal__fab` class overriding geometry to a 56px primary
 *  circle anchored to the calendar's bottom-right edge.
 *
 *  Anchored via `position: absolute` on a `position: relative` parent
 *  (.vq-cal), not viewport-fixed — so the FAB never collides with
 *  consumer page chrome. */
export function CalendarFab(props: CalendarFabProps): ReactNode {
  const messages = useCalendarMessages();
  const { onClick, label = messages.newEvent } = props;
  return (
    <IconButton
      label={label}
      variant="primary"
      size="lg"
      className="vq-cal__fab"
      onClick={onClick}
    >
      <IcnPlus size={22} />
    </IconButton>
  );
}
